import PositionPref from "../../enums/position-pref";
import Pref from "./position-pref";

export default class ReceivedByPositionPref extends Pref {
    constructor(play, fragment) {
        super(play, fragment);
    }

    resolve() {
        return PositionPref.RECEPTION;
    }
}
